import { useContext } from 'react';
import styled from 'styled-components';

import { GraphDataContext } from 'dashboard/components/GraphModule/GraphDataWrapper';
import ModalWrapper from 'dashboard/components/ModalWrapper';
import FormGraphQueryTemplateSaveV2, {
  FormGraphQueryTemplateSaveDataV2,
} from 'dashboard/forms/FormGraphQueryTemplateSave/FormGraphQueryTemplateSaveV2';
import { ModalBody, ModalContainer, ModalHeader } from 'dashboard/layouts/ModalLayout';
import { QueryType } from 'dashboard/models/graph-query';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';
import { BASE } from 'design-system/variables/spacing';

interface TemplateSaveModalProps {
  graphQueryTemplate: GraphQueryTemplate | null;
  isTemplateSaveModalOpen: boolean;
  handleCloseModal: () => void;
  onSubmit: (data: FormGraphQueryTemplateSaveDataV2) => void;
}
const ModalContainerOverflowable = styled(ModalContainer)`
  overflow-y: visible;
  min-width: 740px;
`;
const ModalBodyOverflowable = styled(ModalBody)`
  overflow-y: visible;
  padding: ${BASE * 2}px;
`;
const TemplateSaveModal = ({
  isTemplateSaveModalOpen,
  handleCloseModal,
  graphQueryTemplate,
  onSubmit,
}: TemplateSaveModalProps) => {
  const { graphQueryTemplates } = useContext(GraphDataContext);

  return (
    <ModalWrapper
      isOpen={isTemplateSaveModalOpen}
      handleCloseModal={handleCloseModal}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
    >
      <ModalContainerOverflowable data-test='graph-explorer__template-save-modal'>
        <ModalHeader
          data-test='graph-explorer__template-save-modal__header'
          onClose={handleCloseModal}
        >
          Save Query
        </ModalHeader>
        <ModalBodyOverflowable>
          <FormGraphQueryTemplateSaveV2
            graphQueryTemplate={graphQueryTemplate}
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            graphQueryTemplates={graphQueryTemplates.filter((gqt: GraphQueryTemplate) => {
              return [
                QueryType.ByCluster,
                QueryType.ByAccount,
                QueryType.NHopsFromAccount,
              ].includes(gqt.attributes.type);
            })}
            onSubmit={onSubmit}
            onCancel={handleCloseModal}
          />
        </ModalBodyOverflowable>
      </ModalContainerOverflowable>
    </ModalWrapper>
  );
};

export default TemplateSaveModal;
